// What is a set? It's just an object of key-value pairs.
// You might also know it as a dictionary or hashmap or what have you.
// This is just a more primitive version of the ECMA6 Set & Map.

// const set = {
//     "banana": "yellow",
//     "apple": "red",
//     "lime": "green",
// }

export default class Keyset {
    // Keyset.merge
    // When merging, deletes any values of undefined.
    // When merging, the later arguments will overwrite previous arguments.
    // When merging, will assign a unique identifier to any units missing a key.
    // This is a shallow merge.
    // Returns a new untouched set.
    // Does not touch the passed in sets.
    static merge() {
        const omegaset = {}
        Array.from(arguments).forEach((alphaset) => {
            if(alphaset instanceof Array) {
                alphaset = Keyset.from(alphaset)
            }
            Object.keys(alphaset).forEach((key) => {
                omegaset[key] = alphaset[key]
                if(omegaset[key] == undefined) {
                    delete omegaset[key]
                }
            })
        })
        return omegaset
    }
    // Keyset.map
    // Assumes the "order" from Object.keys, which honestly isn't supposed to have order.
    // For the iterator function, we pass the (value, key) => {}
    // Returns a new untouched set.
    // In the current design, if you change the key in the iterator, it will still be saved in the set by the old key.
    static map(alphaset, iterator) {
        if(alphaset == undefined) {
            return {}
        }
        const omegaset = {}
        Object.keys(alphaset).forEach((key) => {
            omegaset[key] = iterator(alphaset[key], key)
        })
        return omegaset
    }
    // Keyset.find
    // Assumes the "order" from Object.keys, which honestly isn't supposed to have order.
    // For the iterator function, we pass the (value, key) => {}
    static find(set, iterator) {
        if(set == undefined) {
            return undefined
        }
        const keys = Object.keys(set)
        for(let index in keys) {
            const key = keys[index]
            const value = set[key]
            if(iterator(value, key)) {
                return value
            }
        }
    }
    // Keyset.convert
    static convert(alphalist, key = "key") {
        if(alphalist == undefined) {
            return {}
        }
        if(alphalist instanceof Array) {
            const omegaset = {}
            alphalist.forEach((value) => {
                value[key] = value[key] || Keyset.id()
                omegaset[value[key]] = value
            })
            return omegaset
        }
        return alphalist
    }
    static from() {
        return Keyset.convert(...arguments)
    }
    // Keyset.forEach
    // Assumes the "order" from Object.keys, which honestly isn't supposed to have order.
    // For the iterator function, we pass the (value, key) => {}
    static forEach(set, iterator) {
        set = set || []
        Object.keys(set).forEach((key) => {
            const value = set[key]
            iterator(value, key)
        })
    }
}

// You can change the unique
// identifier generator by
// stubbing it out here.
import shortid from "shortid"
Keyset.id = shortid.generate

// TODO: Support keysets that use a different property as the key, like name or id.
